import {QueryClient} from '@tanstack/react-query';

/** Глобальный QueryClient с настройками для проекта. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as {status?: number})?.status;
        if (status && [400, 403, 404].includes(status)) return false;
        return failureCount < 3;
      },
    },
  },
});
